/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Dispatch } from 'redux';
import ActionCreator from '../action-creator';
import { Tokens } from '@okta/okta-auth-js';

export interface AuthTokenPayload {
  tokens: Tokens;
}

export const ActionCreators = {
  SetAuthTokens: new ActionCreator<'SetAuthTokens', AuthTokenPayload>('SetAuthTokens'),
  SignOut: new ActionCreator<'SignOut', {}>('SignOut'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function setAuthTokens(tokens: Tokens): (d: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch(ActionCreators.SetAuthTokens.create({
      tokens
    }));
  }
}

export function signOut(): (d: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch(ActionCreators.SignOut.create());
  }
}
